import {
    Resource,
    HttpIgnore,
} from 'simpli-web-sdk'
import DeliveryMonthResponseSchema from '@/schema/DeliveryMonthResponse.schema'

export default class DeliveryMonthResponse extends Resource {

  readonly $name: string = 'DeliveryMonthResponse'
  readonly $endpoint: string = '/user/indicador/entrega-por-mes'

  get $schema() {
    return DeliveryMonthResponseSchema(this)
  }

  $id = 0
  qtdSemOcorrencia: string | number | null = null
  qtdComOcorrencia: string | number | null = null
  qtdDevolvidas: string | number | null = null
  qtdTotal: string | number | null = null
  data: string  = ''

}
